import { put, logError } from "shared/lib/api"

interface SaveError {
  status?: number | string
  response?: Promise<unknown>
}

interface ValidationError {
  attribute?: string
  message?: string
}

const GENERIC_VALIDATION_MESSAGE =
  "Could not save this Applet template. Please check your data."

// The controller relays IFE's validation body: {errors: [{attribute, message}]}.
const validationMessage = (body: unknown): string => {
  const errors = (body as { errors?: ValidationError[] })?.errors
  if (!Array.isArray(errors)) return GENERIC_VALIDATION_MESSAGE

  const details = errors
    .map(error => [error.attribute, error.message].filter(Boolean).join(" "))
    .filter(detail => detail.length > 0)

  return details.length > 0
    ? `Could not save this Applet template: ${details.join("; ")}`
    : GENERIC_VALIDATION_MESSAGE
}

// IFE rejected the submitted values (the controller relays it as a 422);
// this is a user-data problem, not a fault worth reporting to Sentry.
const isValidationError = (error: SaveError) => error.status === 422

export default function saveStencils(
  endpoint: string,
  payload: object
): Promise<void> {
  return put(endpoint, payload)
    .then(() => {
      window.appendFlash("Applet template saved", "success")
    })
    .catch(async (error: SaveError) => {
      if (isValidationError(error)) {
        const body = await Promise.resolve(error.response).catch(() => null)
        window.appendFlash(validationMessage(body), "danger")
      } else {
        logError(() => {
          window.appendFlash("Failed to save. Try again!", "danger")
        })(error)
      }
    })
}
